// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.local.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:8082/gahapi',
  baseUrl: 'http://localhost:4200',
  stripoPluginStaticSource: 'https://plugins.stripo.email/static/latest/stripo.js',
  stripoPluginAuth : 'https://plugins.stripo.email/api/v1/auth',
  okta: {
    issuer: 'https://spe.oktapreview.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'http://localhost:4200/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'http://localhost:4200'
  },
  oktapublicity: {
    issuer: 'https://spe.oktapreview.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://qa.sonypicturespublicity.net/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://qa.sonypicturespublicity.net'
  },
  oktapublicityaus: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespublicity.com.au/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com.au'
  },
  oktapublicitydotcom: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.com'
  },
  oktapublicityfr: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespresse.fr/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespresse.fr'
  },
  oktapublicitynz: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa22hvnxgr0kv9Ti0h8',
    redirectUri: 'https://www.sonypicturespublicity.co.nz/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://www.sonypicturespublicity.co.nz'
  },
  oktapublicity1: {
    issuer: 'https://spe.okta.com',
    clientId: '0oa14tms8t6U0KIsO358',
    redirectUri: 'https://sonypicturespublicity.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    postLogoutRedirectUri:'https://sonypicturespublicity.com'
  },
captchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  gtmId: 'GTM-54NFTQ9B',
  gtmId_ns: 'GTM-PPVFC757',
  gtmScriptUrl: 'https://www.googletagmanager.com/gtm.js',
  gtmNoScriptUrl: 'https://www.googletagmanager.com/ns.html'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.